import React from "react";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import FormContainer from "../../FormContainer/FormContainer";
import { useStateValue } from "../../../store/StateProvider";
import RegisterHeading from "../../RegisterHeading/RegisterHeading";

const Formpage = () => {
  const [{ formConfig }] = useStateValue();

  return (
    <section className="content">
      <RegisterHeading />
      <ProgressBar formConfig={formConfig} />
      <FormContainer formConfig={formConfig} />
    </section>
  );
};
export default Formpage;
